/**
 * AWS Amplify Configuration
 *
 * Configuration for AWS AppSync and Cognito services
 */

const awsconfig = {
  // AppSync Configuration
  API: {
    GraphQL: {
      endpoint: process.env.REACT_APP_APPSYNC_ENDPOINT || "",
      region: process.env.REACT_APP_APPSYNC_REGION || "us-east-1",
      defaultAuthMode: "userPool", // Using Cognito User Pools
    },
  },

  // Cognito User Pool Configuration (for Amplify Auth)
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || "",
      userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID || "",
      region: process.env.REACT_APP_COGNITO_REGION || "us-east-1",
    },
  },
};

export default awsconfig;
